var map = {
	"./Filter.png": "6428",
	"./Send.png": "229c",
	"./champignons.png": "231c",
	"./check.png": "f0c8",
	"./cheese.png": "96db",
	"./logo.png": "cf05",
	"./onion.png": "4cc1",
	"./pepper.png": "306f",
	"./pizza.png": "908c",
	"./stocks/cashback.png": "6ddf",
	"./stocks/pizzaStocks.png": "9944",
	"./success.png": "6582",
	"./Акции.png": "e867",
	"./Десерты.png": "4713",
	"./Закуски.png": "5b36",
	"./Комбо.png": "cc4d",
	"./Напитки.png": "a145",
	"./Пицца.png": "7bfe",
	"./Соусы.png": "7a37",
	"./Суши.png": "167a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";